import { type App, type DateRange, type EntityFilter, GetTimeReportsParams, TimeEntryType } from "@pentacode/core";

export const timeReportsKey = ["time-reports", "all-employees"] as const;

export function timeReportsQuery(app: App, range: DateRange, filters: EntityFilter[]) {
    return {
        queryKey: [...timeReportsKey, range.from, range.to, filters] as const,
        queryFn: ({ signal }: { signal: AbortSignal }) =>
            app.api.getTimeReports(
                new GetTimeReportsParams({
                    ...range,
                    filters,
                    resolution: "none",
                    types: [
                        TimeEntryType.Work,
                        TimeEntryType.Vacation,
                        TimeEntryType.Sick,
                        TimeEntryType.ChildSick,
                        TimeEntryType.SickInKUG,
                    ],
                }),
                { signal }
            ),
    };
}
